module.exports = __webpack_public_path__ + "img/cards.36b0e1ac.png";